import { render, staticRenderFns } from "./FancyChooser.vue?vue&type=template&id=07932296&scoped=true&"
import script from "./FancyChooser.vue?vue&type=script&lang=js&"
export * from "./FancyChooser.vue?vue&type=script&lang=js&"
import style0 from "./FancyChooser.vue?vue&type=style&index=0&id=07932296&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07932296",
  null
  
)

export default component.exports